define('toolkit/b-controls-group-utils/b-controls-group-utils', [
	'jquery',
	'toolkit/b-toolkit/b-toolkit'
], function ($, toolkit) {
	'use strict';


	return toolkit.create('b-controls-group-utils', {
		service: true,

		_getUIEvent: function (evt) {
			var $el = $(evt.currentTarget);
			var $group = $el.closest('[data-group]', this.el);
			var id = $el.attr('data-id');
			var name = $el.attr('data-name');
			var EVENT_REGEXP = /[^A-Za-z0-9-_]/g;
			// Определяем имя события и чистим имя, чтобы jQuery не взрывался (MAIL-51845)
			if (name) {
				name = name.replace(EVENT_REGEXP, '');
			}

			// Если не найдена группа внутри el, проверим, может быть сам el - это группа!
			// MAIL-46560
			if (!$group.length) {
				$group = this.$el.filter('[data-group]');
			}

			return {
				el: $el[0],
				$el: $el,
				id: id || $el.closest('[data-id]', this.el).attr('data-id'),
				name: name,
				group: $group.attr('data-group'),
				disabled: $el.is('[aria-disabled]') || $group.is('[aria-disabled]'),
				event: evt
			};
		},

		_emitUIEvent: function (evt){
			var uiEvt = this._getUIEvent(evt)
			  , eventName = (uiEvt.group || uiEvt.name || 'no-name').replace(/_/g, '-')
			;

			if( uiEvt.disabled ){
				evt.preventDefault();
			}
			else {
				if( uiEvt.$el ){
					// Адова логика, я сам уже не понимаю что это всё!
					var $a = uiEvt.$el.closest('a');

					if( !($a.attr('href') || $a.attr('rel') == 'history') ){
						evt.preventDefault();
					}
				}

				this.emit(eventName, uiEvt);

				if (uiEvt.group && (uiEvt.name || uiEvt.id)) {
					this.emit(eventName + ':' + (uiEvt.name || uiEvt.id), uiEvt);

					if (uiEvt.name && uiEvt.id) {
						this.emit(eventName + ':' + uiEvt.name + ':' + uiEvt.id, uiEvt);
					}
				}
			}
		}
	});
});
